import { requester } from '../utils';

export const introducedCafe = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/introduced-cafe`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('introduced cafe error', err);
        reject(err);
      });
  });
};
